export function getBannerPlainText(html) {
  if (!html) return '';
  if (typeof document !== 'undefined') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
  }
  return String(html)
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function isBannerHtmlEmpty(html) {
  return getBannerPlainText(html).length === 0;
}

export const MAX_BANNER_PLAIN_LENGTH = 500;
export const DEFAULT_SCROLL_SPEED_SECONDS = 50;
export const MIN_SCROLL_SPEED_SECONDS = 15;
export const MAX_SCROLL_SPEED_SECONDS = 120;
